import React from 'react'

export default class NotFound extends React.Component {
  render(){
    return(
      <h1 className='loading'>404.. This page is not found!</h1>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js